<template>
  <div class="mx-2">
    <v-row dense class="pa-4 white--text mb-4 mt-3" style="background-color: #39C57B; margin: 0 1px">
      <v-col cols="12" lg="8">
        <div class="body-1">
          Pilih salah satu periode yang tersedia untuk melihat detail dari laporan <br />
          <b>{{ $getDeepObj(detail, 'nama') || '-' }}</b>
        </div>
      </v-col>
      <v-col cols="12" lg="4" class="text-right">
        <v-menu>
          <template v-slot:activator="{ attrs, on }">
            <v-btn depressed x-large style="background-color: #FDFFCF; border-radius: 5pt" v-bind="attrs" v-on="on">
              <v-row dense>
                <v-col cols="10" class="text-left">
                  <span style="font-size: 10px" class="text-lowercase">
                    <span class="text-capitalize">Jadwal</span> yang ditampilkan
                  </span>
                  <p class="success--text mb-0 text-capitalize">
                    {{ (mPertemuan && mPertemuan[pendampingan_ke]) || '-' }}
                  </p>
                </v-col>
                <v-col cols="2">
                  <v-icon right dark color="#39C57B" class="pt-5">mdi-chevron-down</v-icon>
                </v-col>
              </v-row>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group color="primary">
              <template v-for="(item, key) in listPertemuan">
                <v-divider v-if="key !== 0" :key="`divider-${key}`"></v-divider>
                <v-list-item :key="item" link @click="onChangePendampinganKe(item)">
                  <v-list-item-title v-text="mPertemuan[item]"></v-list-item-title>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-list v-for="(item, id) in sekolahs" :key="id" class="pb-0">
      <div :key="id">
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-hospital-building</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text body-1">
                      {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                    </div>
                    <div class="black--text">
                      <b>NPSN : </b>
                      {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <div class="caption grey--text mb-0">Alamat Sekolah</div>
                    <div class="link black--text body-2">
                      <div>{{ $getDeepObj(item, 'sekolah.data.alamat') || '-' }}</div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <div>
                      <v-chip
                        :color="
                          Number($getDeepObj(item, `psp_kp_pa_sekolah_${type}s.data.0.is_lengkap`)) === 1
                            ? 'success'
                            : 'orange'
                        "
                        dark
                        small
                      >
                        {{
                          Number($getDeepObj(item, `psp_kp_pa_sekolah_${type}s.data.0.is_lengkap`)) === 1
                            ? 'Sudah Lengkap'
                            : 'Belum Lengkap'
                        }}
                      </v-chip>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <div>
                      <v-btn color="secondary" class="white--text" small @click="onDetailLaporan(item, true)">
                        <v-icon left dark>
                          mdi-eye
                        </v-icon>
                        Lihat Laporan
                      </v-btn>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="id + 1 < sekolahs.length" />
      </div>
    </v-list>
    <base-modal-full
      ref="modal"
      :title="formulir.title"
      :auto-close="formulir.isPreview"
      :use-save="!formulir.isPreview"
    >
      <component
        ref="formulir"
        :is="formulir.component"
        :initValue="formulir.init"
        :berkases="formulir.berkases || []"
        :is-preview="formulir.isPreview"
        :psp-kp-pa="detail"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import FormulirVisitasi from '@views/gtk/laporan/lingkup/formulir/Visitasi';
import FormulirRefleksi from '@views/gtk/laporan/lingkup/formulir/Refleksi';

export default {
  name: 'DetailPendampinganLingkupLaporan',
  components: { FormulirVisitasi, FormulirRefleksi },
  props: {
    detail: {
      type: Object,
    },
    config: {
      type: Object,
      default: () => {},
    },
    periodes: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      type: null,
      pendampingan_ke: null,
      component: null,
      formulir: {},
      pspKpPaPendampingan: {},
      pspKpPaSekolahId: '',
      sekolahs: [],
    };
  },
  computed: {
    mPertemuan() {
      if (this.type === 'refleksi') {
        return this.config['pendampingan_ke-refleksi'] || {};
      }

      return this.config['pendampingan_ke-visitasi'] || {};
    },

    listPertemuan() {
      return Object.keys(this.mPertemuan);
    },
  },
  methods: {
    ...mapActions('lingkup', ['getDetailSekolah', 'getDetailLaporan']),

    fetch(type = '') {
      if (!this.pendampingan_ke || this.type !== type) {
        this.type = type;
        this.pendampingan_ke = this.periodes[`pendampingan_ke-${this.type}`];
      }

      // get pspKpPaPendampingan
      const pspKpPaPendamingans = (this.$getDeepObj(this.detail, 'psp_kp_pa_pendampingans.data') || []).filter(
        (pendampingan) => +pendampingan.pendampingan_ke === +this.pendampingan_ke
      );
      this.pspKpPaPendampingan = pspKpPaPendamingans[0] || {};

      // get Sekolahs
      const pspKpPaPendampinganId = this.pspKpPaPendampingan.psp_kp_pa_pendampingan_id || '';

      if (!pspKpPaPendampinganId) return;

      this.getDetailSekolah({ id: pspKpPaPendampinganId, type }).then(({ data }) => {
        this.sekolahs = data || [];
      });
    },

    async detailData() {
      const id = this.pspKpPaPendampingan && this.pspKpPaPendampingan['psp_kp_pa_pendampingan_id'];
      const type = this.type;
      const sekolahId = this.pspKpPaSekolahId;
      const resp = await this.getDetailLaporan({ id, type, sekolahId });

      return resp.data || {};
    },

    onChangePendampinganKe(value) {
      this.pendampingan_ke = value;
      this.fetch(this.type);
    },

    async onDetailLaporan(data) {
      this.$set(this.formulir, 'init', null);

      // get detail data
      this.pspKpPaSekolahId = data.psp_kp_pa_sekolah_id;
      const detail = await this.detailData();

      // type (refleksi / visitasi)
      const pspKpPaSekolahDetail = this.$getDeepObj(data, `psp_kp_pa_sekolah_${this.type}s.data.0`) || {};
      const berkases = this.$getDeepObj(detail, `psp_kp_pa_sekolah_${this.type}_berkases.data`) || [];
      const pendampinganKe = this.pspKpPaPendampingan['pendampingan_ke'] || '';
      const init = {
        pspKpPaSekolahDetail,
        pspKpPaSekolahId: this.pspKpPaSekolahId,
        pspKpPaPendampingan: this.pspKpPaPendampingan,
        jadwal: this.$getDeepObj(this.config, `pendampingan_ke-${this.type}.${pendampinganKe}`) || '',
        sekolah: data.sekolah || {},
      };

      const titles = {
        visitasi: 'Formulir Laporan Kunjungan Lapangan',
        refleksi: 'Formulir Laporan Refleksi Satuan Pendidikan',
      };
      const forms = {
        visitasi: 'FormulirVisitasi',
        refleksi: 'FormulirRefleksi',
      };

      this.$set(this.formulir, 'title', titles[this.type]);
      this.$set(this.formulir, 'component', forms[this.type]);
      this.$set(this.formulir, 'berkases', berkases);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
        this.$set(this.formulir, 'isPreview', true);
      });
    },
  },
};
</script>

<style scoped></style>
